let intersectionObserver: IntersectionObserver | null = null
let resizeObserver: ResizeObserver | null = null

function calculateWidgetPosition() {
  const zendeskButton = document.querySelector("#zendesk-widget-button .help-button") as HTMLElement | null

  if (document.body.classList.contains("checkout-upgrade-modal-open")) {
    intersectionObserver?.disconnect()
    document.documentElement.style.removeProperty("--zendesk-widget-bottom")
    if (zendeskButton) zendeskButton.style.visibility = "visible"
    return
  }

  const footer = document.querySelector(".site-footer") as HTMLElement | null
  if (!footer || !zendeskButton) return

  const footerTopFromDocument = footer.offsetTop
  const distanceFromBottom = window.innerHeight - footerTopFromDocument
  const bottomPosition = Math.max(distanceFromBottom, 0)
  document.documentElement.style.setProperty("--zendesk-widget-bottom", `${bottomPosition}px`)

  intersectionObserver?.disconnect()

  requestAnimationFrame(() => {
    intersectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const widgetRect = zendeskButton.getBoundingClientRect()
          const footerCurrentRect = entry.boundingClientRect
          const isOverlapping = widgetRect.top > footerCurrentRect.top

          zendeskButton.style.visibility = isOverlapping ? "hidden" : "visible"
        })
      },
      { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.66, 0.75] }
    )

    intersectionObserver.observe(footer)
  })
}

/** Re-run footer / modal layout rules (e.g. after checkout modal reparents the launcher). */
export function recalculateHelpWidgetVisibility() {
  calculateWidgetPosition()
}

export default function toggleHelpWidgetVisibility() {
  calculateWidgetPosition()

  const mainElement = document.querySelector("main")
  if (mainElement) {
    resizeObserver = new ResizeObserver(() => {
      calculateWidgetPosition()
    })
    resizeObserver.observe(mainElement)
  }

  return () => {
    intersectionObserver?.disconnect()
    resizeObserver?.disconnect()
  }
}
